export const POPULAR_SEARCH_TAGS = [
  'Question',
  'Arrow',
  'Confetti',
  'Checkmark',
  'Money',
  'Phone',
  'Heart',
  'Email',
  'Brain',
  'Check',
  'Instagram',
  'School',
  'Team',
];

export const DEFAULT_HARDCODED_TAGS = ['Business', 'Technology', 'Healthcare', 'People'];

export const RANDOM_TAG = POPULAR_SEARCH_TAGS[Math.floor(Math.random() * POPULAR_SEARCH_TAGS.length)];

export const DEFAULT_LOTTIE_SIZE_WIDTH = 120;

export const DEFAULT_LOTTIE_SIZE_HEIGHT = 125;

export const PROVIDED_BY_GUTTER = 10;
